export enum WebPlatformFeatureFlags {
  EnableOneTrust = 'enableOneTrust',
  EnablePostGeoRedirectModal = 'enablePostGeoRedirectModal',
  EnableSentry = 'enableSentry',
  IdpSecondaryLoginEnabled = 'idp-secondary-login-enabled',
  WPDisableRemoveSubdomainCookies = 'wp-disable-remove-subdomain-cookies',
  WPEnableWsDisconnectSentryReporting = 'wp-enable-ws-disconnect-sentry-reporting',
  WPKongFeatureSentryLog = 'WP-kong-feature-sentry-log'
}
